import { css } from 'emotion'
import { MenuLink, Easings } from './..'

export const FeaturedStyle = (ready) => css({
  margin: '4rem 0',
  transition: `opacity 400ms ease, transform 400ms ${Easings.customEase}`,
  transform: `translateY(${ready ? 0 : 20}px)`,
  opacity: ready ? 1 : 0,
  'h2': {
    ...MenuLink,
    color: 'white',
    // margin: '1rem 0',
  },
  '.card': {
    minWidth: 280,
  }
})




// WEBPACK FOOTER //
// ./src/styles/components/featured.js